import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const PhoneSvg = ({ color = "primary", bg, iconStyle, ...rest }) => {
  return (
    <Svg
      width="33"
      height="33"
      viewBox="-6.6 0 27 13.4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M0.70824 5.58042C2.33751 9.13105 5.23661 11.954 8.84097 13.4844L9.41874 13.742C10.7406 14.3313 12.2945 13.8835 13.1008 12.6811L13.8558 11.5551C14.1013 11.189 14.0265 10.6959 13.6836 10.419L11.123 8.35209C10.7469 8.04849 10.1939 8.1192 9.90613 8.50767L9.114 9.57719C7.0814 8.57396 5.43117 6.92275 4.42852 4.88895L5.4974 4.09636C5.88564 3.80847 5.95632 3.2551 5.6529 2.87877L3.58708 0.316588C3.31048 -0.0264735 2.8178 -0.101305 2.45192 0.144173L1.31877 0.904419C0.10953 1.71572 -0.335435 3.28338 0.267111 4.60954L0.707577 5.57898L0.70824 5.58042Z"
        fill={color}
      />
    </Svg>
  )
}

export default PhoneSvg
